import React from 'react';
import InputField from 'Components/InputField/InputField';

const EmailField = () => {
  return (
    <InputField placeholder='Email' />
  )
}

export default EmailField;